import { render, staticRenderFns } from "./seltos-video-popup-swiper.vue?vue&type=template&id=c18c2a4c&scoped=true&"
import script from "./seltos-video-popup-swiper.vue?vue&type=script&lang=js&"
export * from "./seltos-video-popup-swiper.vue?vue&type=script&lang=js&"
import style0 from "./seltos-video-popup-swiper.vue?vue&type=style&index=0&id=c18c2a4c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c18c2a4c",
  null
  
)

export default component.exports